import { type ReactElement, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import apis from '../../libs/services'
import { useAuth } from '../../hooks/useAuth'
import { PageTitle } from '../../components/atoms'

function SAML2Callback (): ReactElement {
  const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing')
  const [errorMessage, setErrorMessage] = useState<string>('')
  const navigate = useNavigate()
  const { setUserProfile } = useAuth()

  useEffect(() => {
    const handleSAMLResponse = async (): Promise<void> => {
      try {
        // Get SAML response from URL
        const urlParams = new URLSearchParams(window.location.search)
        const samlResponse = urlParams.get('SAMLResponse')

        if (samlResponse === null) {
          throw new Error('No SAML response received')
        }

        // Send SAML response to backend for validation
        const tokenResponse = await apis.validateSAMLResponse({ samlResponse })
        const dopageToken = tokenResponse.data.data.accessToken

        // Store token
        localStorage.setItem('dopageAccessToken', dopageToken)

        // Fetch user profile
        const profileRes = await apis.getUserProfile()
        const profileData = profileRes?.data?.data
        setUserProfile(profileData)

        setStatus('success')

        // Navigate based on role
        if (profileData.user_profile.accepted_terms === true) {
          if (profileData.role.slug === 'admin') {
            navigate('/dashboard/all-assigned-students')
          } else {
            navigate('/user-dashboard')
          }
        } else {
          navigate('/terms-of-use')
        }
      } catch (error) {
        console.error('SAML authentication error:', error)
        setStatus('error')
        setErrorMessage('Authentication failed. Please try again.')
      }
    }

    void handleSAMLResponse()
  }, [navigate, setUserProfile])

  // Render loading, success, or error state
  return (
    <div className='bg-black min-h-[100dvh] font-primary flex flex-col items-center justify-center'>
      <PageTitle title='SAML Authentication' />
      {status === 'processing' && (
        <div className='text-white text-[26px]'>Authenticating...</div>
      )}
      {status === 'error' && (
        <div className='text-red-500 text-[26px]'>Error: {errorMessage}</div>
      )}
    </div>
  )
}

export default SAML2Callback

